import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './locales/en.json';
import nl from './locales/nl.json';
import fr from './locales/fr.json';

/**
 * Detect initial language from browser settings.
 * Returns 'nl', 'fr', or 'en' (default).
 */
function detectBrowserLanguage() {
  const lang = navigator.language || navigator.userLanguage || 'en';
  const code = lang.split('-')[0].toLowerCase();
  if (code === 'nl') return 'nl';
  if (code === 'fr') return 'fr';
  return 'en';
}

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    nl: { translation: nl },
    fr: { translation: fr },
  },
  lng: detectBrowserLanguage(),
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
